import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { PlatformFeatures } from './components/PlatformFeatures';
import { UseCases } from './components/UseCases';
import { Founders } from './components/Founders';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { Partners } from './components/Partners';
function HomePage() {
  return <div className="min-h-screen bg-hubble-bg text-hubble-text font-body selection:bg-hubble-primary selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <HowItWorks data-id="element-4" />
        <PlatformFeatures data-id="element-5" />
        <UseCases data-id="element-6" />
        <Founders data-id="element-7" />
        <CTASection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-10">
      <Routes data-id="element-11">
        <Route path="/" element={<HomePage data-id="element-13" />} data-id="element-12" />
        <Route path="/partners" element={<Partners data-id="element-15" />} data-id="element-14" />
      </Routes>
    </BrowserRouter>;
}